import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import backRed from "../../../assets/svg/back-rose-icon.svg";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import SucessModal from "../../../components/Modal/SucessModal";

export default function CategoryForm({ edit = false, view = false }) {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();
  const [checked, setChecked] = useState(true);
  const { id } = useParams();
  const [fields, setFields] = useState({});

  const onSubmit = (fields) => {
    axios
      .post(
        `${process.env.REACT_APP_API_URL}health-article-category/create`,
        fields,
      )
      .then((response) => {
        if (response.data?._id) {
          setSuccess(true);
        } else {
          alert("Fail");
          console.log("failed...");
        }
      });
  };

  const [menu, setMenu] = useState([]);

  useEffect(() => {
    axios
      .post(`${process.env.REACT_APP_API_URL}health-article-menu/list`)
      .then((res) => {
        setMenu(res.data.rows);
      });
  }, []);

  const breadcrumbsList = useMemo(
    () => [
      { text: "Manage Menu and Category", link: "/healtharticlemenu" },
      { text: "Add New Category", link: "" },
    ],
    [],
  );

  const handleUpdateData = () => {
    let item = {
      menu: fields.menu,
      category: fields.category,
      active: fields.active,
    };
    fetch(
      `${process.env.REACT_APP_API_URL}health-article-category/update/${id}`,
      {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      },
    ).then((result) => {
      result.json().then((resp) => {
        setSuccess(true);
      });
    });
  };

  const getCategoryData = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}health-article-category/get/${id}`)
      .then((response) => {
        setFields(response.data);
      })
      .catch((err) => {
        console.error(err);
        alert("Some error");
      });
  };

  useEffect(() => {
    (edit || view) && getCategoryData();
  }, []);

  useEffect(() => {
    axios
      .post(`${process.env.REACT_APP_API_URL}health-article-menu/list`)
      .then((res) => {
        setMenu(res.data.rows);
      });
  }, []);

  return (
    <div>
      <Breadcrumbs
        className="w-75 healthsyMasterBreadCrumbs"
        breadcrumbsList={breadcrumbsList}
      />
      {/* <Home> */}
      <div onClick={() => navigate("/Category")} className="rose back-button">
        <img src={backRed} alt="" />
        <span className="rose-back">Back</span>
      </div>
      <div className="healtharticle">
        <div className="healtharticle-container category-container ps-3">
          {/* <div className="healtharticle-title">
            <Link
              to="/dashboard"
              style={{
                textDecoration: "none",
                color: "black",
                fontSize: "15px",
              }}
            >
              <span style={{}}>Dashboard</span>
            </Link>
            <span>{`>`}</span>
            <Link
              to="/healtharticlemenu"
              style={{
                textDecoration: "none",
                color: "black",
                paddingLeft: "0.5%",
              }}
            >
              <span>Manage Menu and Category</span>
            </Link>
            <span style={{ fontSize: "15px", paddingLeft: "0.4%" }}>{`>`}</span>
            <span style={{ paddingLeft: "0.4%" }}>Add New Category</span>
          </div> */}
          <form
            onSubmit={(e) => {
              e.preventDefault();
              edit ? handleUpdateData() : onSubmit(fields);
            }}
          >
            <div className="row mt-5 ms-2">
              <div className="col-3">
                <label className="form-label " htmlFor="">
                  Menu <span className="star ">*</span>
                </label>
                {/* <input className='form-control w-100 ' type="text" name="" id="" placeholder='Enter'/> */}
                <select
                  className="category-select w-100 "
                  name=""
                  id="menu"
                  value={fields.menu}
                  onChange={(e) =>
                    setFields((prevState) => {
                      return { ...prevState, menu: e.target.value };
                    })
                  }
                >
                  <option selected hidden>
                    Select Menu
                  </option>
                  {menu.map((el) => {
                    return <option value={el.name}>{el.name}</option>;
                  })}
                </select>
                {errors.menu && (
                  <div className={`invalid-feedback d-block`}>
                    Please Select an Option
                  </div>
                )}
              </div>
              <div className="col-4 ms-3">
                <label className="form-label " htmlFor="">
                  Category <span className="star ">*</span>
                </label>
                <input
                  className="form-control w-100 category-input"
                  type="text"
                  name=""
                  id="category"
                  value={fields.category}
                  onChange={(e) =>
                    setFields((prevState) => {
                      return { ...prevState, category: e.target.value };
                    })
                  }
                  placeholder="category"
                />
                {errors.category && (
                  <div className={`invalid-feedback d-block`}>
                    Please Enter Category
                  </div>
                )}
              </div>
            </div>

            <div className="row ms-2">
              <label htmlFor="" className="mb-3 mt-3 ">
                Active Status <span className="star">*</span>
              </label>
              <div className="d-flex p-0">
                <div className="form-check form-check-inline m-0">
                  <input
                    className=" me-3"
                    type="radio"
                    name="active"
                    id="active"
                    onChange={(e) => {
                      setFields((prevState) => {
                        return { ...prevState, active: true };
                      });
                    }}
                    value={true}
                    checked={fields.active === true ? "checked" : null}
                  />
                  <label className="" htmlFor="inline1">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="me-3"
                    type="radio"
                    name="active"
                    id="status"
                    value={false}
                    onChange={(e) => {
                      setFields((prevState) => {
                        return { ...prevState, active: false };
                      });
                    }}
                    checked={fields.active === false ? "checked" : null}
                  />
                  <label className="" htmlFor="inline2">
                    No
                  </label>
                </div>
              </div>
              {errors.status && (
                <div className={`invalid-feedback d-block`}>
                  Please Select an Option
                </div>
              )}
            </div>
            {!view && (
              <div className="d-flex justify-content-center category-btn">
                <button type="submit" className="add-button">
                  ADD
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
      {/* </Home> */}
      {success && (
        <SucessModal
          page={"/Category"}
          name="Health Article Category"
          post="posted"
        />
      )}
    </div>
  );
}
